module.exports = __webpack_public_path__ + "media/img/video-icon-919c52c7227f1f2cc04cad9fff42b8ab.png";